import { ISusuario, Usuario } from "../usuario/Usuario";
import { ISusuarioList, UsuarioList } from "../usuario/UsuarioList";
import { ISprocesso, Processo } from "./Processo";

export interface ProcessoBloco {
    id: string;
    usuario: Usuario;
    processoId: string;
    blocoId: string;
    observacao: string | null;
}

export const ISprocessoBloco: ProcessoBloco = {
    id: "",
    usuario: ISusuario,
    processoId: "",
    blocoId: "",
    observacao: null,

}